import { CollectionEventSummaryModel } from "@/api/CollectionEvents";

export const addDataCyToCollectionEventIcons = (collectionEvents: CollectionEventSummaryModel[]) => {
  if (collectionEvents.length == 0) return;

  const markerContainer = document.querySelector("div.leaflet-pane.leaflet-marker-pane");

  if (markerContainer == null) return;

  const addressLookup: { [id: string]: string } = {};

  for (let i = 0; i < collectionEvents.length; i++) {
    const collectionEvent = collectionEvents[i];
    addressLookup[collectionEvent.id] = collectionEvent.wasteStreamId + "-" + collectionEvent.addressHash.replace(/ /g, "");
  }

  const imgs = markerContainer.querySelectorAll("img.leaflet-marker-icon");

  for (let i = 0; i < imgs.length; i++) {
    const img = imgs[i];
    const alt = img.getAttribute("alt");
    if (alt) {
      const dataCy = addressLookup[alt.split("-")[2]];
      img.setAttribute("data-cy", dataCy);
    }
  }
};

//Only apply to custom component ComboBox
export const addDataCyToComboBox = () => {
  function findAncestorByClass(element: HTMLElement | null, className: string) {
    while ((element = element?.parentElement ?? null) && !element.classList.contains(className));
    return element;
  }

  function GenerateDataCyAttributesInPopup(link: Element) {
    const titles = link.querySelectorAll("div.v-list-item__title");
    if (titles.length <= 0) return;

    const titleDiv = titles[0] as HTMLDivElement;
    const titleText = titleDiv.innerHTML.replace(/ /g, "-");
    const dataCyTitleDiv = titleText.toLowerCase() + "-title";
    titleDiv.setAttribute("data-cy", dataCyTitleDiv);

    const dataCyLink = titleText.toLowerCase() + "-link";
    link.setAttribute("data-cy", dataCyLink);
  }

  function SetDataCyToSelections(selectedPopupDiv: Element) {
    const links = selectedPopupDiv.querySelectorAll("div.v-list-item--link");

    for (let j = 0; j < links.length; j++) {
      const link = links[j];
      GenerateDataCyAttributesInPopup(link);
    }
  }

  //by default, v-complete only loads 20 selections in 'v-list-item--link' class at the beginning
  //when scrolling down, more selections will be added to the list dynamically
  //therefore, we need another MutationObserver to handle the extra selections
  function SetDataCyToSelectionsCallback(records: MutationRecord[]) {
    for (const record of records) {
      for (const addedNode of record.addedNodes) {
        const nodeElement = addedNode as Element;
        GenerateDataCyAttributesInPopup(nodeElement);
      }
    }
  }

  function GenerateDataCyAttributesToPopup(selectedPopupDiv: Element) {
    const id = selectedPopupDiv.children[0].id;
    const numId = id.split("-")[1];
    const inputId = "input-" + numId;

    const inputCtrl = document.getElementById(inputId);
    const outerDiv = findAncestorByClass(inputCtrl, "v-input");

    if (outerDiv != null && outerDiv.classList.contains("combobox")) {
      const inputElement = outerDiv.getElementsByTagName("input")[0];
      const dataCyPrefix = inputElement.getAttribute("data-cy") as string;
      const dataCyDiv = dataCyPrefix.replace(/ /g, "-") + "-div";

      selectedPopupDiv.setAttribute("data-cy", dataCyDiv);

      const observer = new MutationObserver(SetDataCyToSelectionsCallback);
      observer.observe(selectedPopupDiv.children[0], { childList: true });

      SetDataCyToSelections(selectedPopupDiv);
    }
  }

  function SetDataCyToDiv() {
    const autoCompletes = document.querySelectorAll("div.v-autocomplete__content");
    for (let i = 0; i < autoCompletes.length; i++) {
      const selectedPopupDiv = autoCompletes[i];
      GenerateDataCyAttributesToPopup(selectedPopupDiv);
    }
  }

  //v-complete in ComboBox is in lazy loading mode.
  //popup wrapper div with 'v-autocomplete__content' class will be added to outer div with 'v-application--is-ltr' class dynamically, when the popup is displayed.
  //therefore, we use MutationObserver to handle the extra popup div
  function SetDataCyToDivCallBack(records: MutationRecord[]) {
    for (const record of records) {
      for (const addedNode of record.addedNodes) {
        const nodeElement = addedNode as Element;
        GenerateDataCyAttributesToPopup(nodeElement);
      }
    }
  }

  function DataCyInit() {
    const applicationList = document.getElementsByClassName("v-application--is-ltr") as HTMLCollection;

    if (applicationList.length <= 0) return;

    const applicationObserver = new MutationObserver(SetDataCyToDivCallBack);
    applicationObserver.observe(applicationList[0], { childList: true });

    SetDataCyToDiv();
  }

  DataCyInit();
};
